/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterStone_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterStone_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterStone_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStone_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '51c1ccd987d2f60795b64672a28c5f8e';
module.exports = node;
